import actionRequest from './actionRequest.json'
import actions from './actions.json'
import alert from './alert.json'
import asset from './asset.json'
import breadcrumbs from './breadcrumbs.json'
import catalogProduct from './catalogProduct.json'
import common from './common.json'
import device from './device.json'
import generator from './generator.json'
import heater from './heater.json'
import installation from './installation.json'
import manufacturing from './manufacturing.json'
import sms from './sms.json'
import validation from './validation.json'
import valve from './valve.json'
import ruuvitag from './ruuvitag.json'
import powerSupply from './powerSupply.json'
import graph from './graph.json'
import sensor from './sensor.json'

export default {
  actionRequest,
  actions,
  alert,
  asset,
  breadcrumbs,
  catalogProduct,
  graph,
  common,
  device,
  generator,
  heater,
  installation,
  manufacturing,
  powerSupply,
  ruuvitag,
  sms,
  sensor,
  validation,
  valve
}
